import ko from 'knockout';
import axios from "axios";
import { Dropdown } from "bootstrap";
import { initLoadMore } from './catalog/load-more';

function SortByToFriendly(sortOn: string): string {
    switch (sortOn) {
        case "asc":
            return "Price: Low to High";
        case "desc":
            return "Price: High to Low";
        case "best":
            return "Best Selling";
        default:
            return "Price: Low to High";
    }
}

interface SelectedFilter {
    FacetName: string;
    FacetNameSlug: string;
    FacetValue: string;
    FacetValueSlug: string;
}

interface RangeFilter {
    facetSlug: string;
    min: number;
    max: number;
}

var FiltersV3 = {
    SortByToFriendly: function (sortOn: string): string {
        return SortByToFriendly(sortOn);
    },

    init: async function (data: KnockoutObservableArray<SelectedFilter>, sortByData: KnockoutObservable<string>) {
        const rangeFilters: Map<string, RangeFilter> = new Map();

        // Sort by dropdown handlers
        $(".sortBy").on('click', function () {
            var sortOn = $(this).attr('data-sortOn');
            sortByData(sortOn);
            $(".sortByText").html(SortByToFriendly(sortByData()));
            updateFromFilters();

            var el = document.getElementById('sortByDropdown');
            var dd = Dropdown.getInstance(el);
            dd?.hide();
            return false;
        });

        // Clear all filters
        $("#btn-clear-filters").on('click', function (e) {
            data.removeAll();
            rangeFilters.clear();
            $(".facet-checkbox-v3, .facet-toggle-v3").prop('checked', false);
            $(".facet-radio-v3").prop('checked', false);
            $(".facet-color-swatch").removeClass('selected');

            // Reset range sliders
            $(".facet-range-slider").each(function () {
                const container = $(this);
                const min = parseFloat(container.data('min'));
                const max = parseFloat(container.data('max'));
                container.find('.range-min-input, .range-slider-min').val(min);
                container.find('.range-max-input, .range-slider-max').val(max);
            });

            updateFromFilters();
        });

        // Mobile filter toggle - handled by V2 filters.ts to avoid double-binding

        // Remove selected filter tag
        $("#products-browse").on('click', ".selected-filter-tag", function () {
            let facetNameSlug = $(this).attr('data-facetNameSlug');
            let facetValueSlug = $(this).attr('data-facetValueSlug');

            // Uncheck the corresponding checkbox/radio/toggle
            $(`#facetv3_${facetNameSlug}_${facetValueSlug}`).prop('checked', false);
            $(`#facetv3_radio_${facetNameSlug}_${facetValueSlug}`).prop('checked', false);
            $(`#facetv3_toggle_${facetNameSlug}_${facetValueSlug}`).prop('checked', false);

            // Remove swatch selection
            $(`.facet-color-swatch[data-facet-slug="${facetNameSlug}"][data-facet-value-slug="${facetValueSlug}"]`).removeClass('selected');

            // Remove from selected filter
            data.remove(function (item) {
                return (ko.unwrap(item.FacetNameSlug) == facetNameSlug && ko.unwrap(item.FacetValueSlug) == facetValueSlug);
            });

            // Remove range filter if applicable
            rangeFilters.delete(facetNameSlug);

            updateFromFilters();
        });

        // Checkbox handlers
        $(document).on('change', '.facet-checkbox-v3', function (e) {
            const checkbox = e.currentTarget as HTMLInputElement;
            handleCheckboxChange(checkbox);
        });

        // Radio handlers
        $(document).on('change', '.facet-radio-v3', function (e) {
            const radio = e.currentTarget as HTMLInputElement;
            handleRadioChange(radio);
        });

        // Toggle handlers
        $(document).on('change', '.facet-toggle-v3', function (e) {
            const toggle = e.currentTarget as HTMLInputElement;
            handleCheckboxChange(toggle);
        });

        // Color swatch handlers
        $(document).on('click', '.facet-color-swatch', function (e) {
            e.preventDefault();
            const swatch = $(this);
            const facetSlug = swatch.data('facet-slug');
            const valueSlug = swatch.data('facet-value-slug');
            const isSelected = swatch.hasClass('selected');

            if (isSelected) {
                swatch.removeClass('selected');
                data.remove(function (item) {
                    return (ko.unwrap(item.FacetNameSlug) == facetSlug && ko.unwrap(item.FacetValueSlug) == valueSlug);
                });
            } else {
                swatch.addClass('selected');
                data.push({
                    FacetName: swatch.attr('title') || '',
                    FacetNameSlug: facetSlug,
                    FacetValue: swatch.attr('title') || '',
                    FacetValueSlug: valueSlug
                });
            }

            updateFromFilters();
        });

        // Range slider handlers
        $(document).on('input', '.range-slider-min, .range-slider-max', function () {
            const container = $(this).closest('.facet-range-slider');
            syncRangeInputs(container, 'slider');
        });

        $(document).on('change', '.range-min-input, .range-max-input', function () {
            const container = $(this).closest('.facet-range-slider');
            syncRangeInputs(container, 'input');
        });

        // Apply range filter button
        $(document).on('click', '.apply-range-filter', function () {
            const container = $(this).closest('.facet-range-slider');
            const facetSlug = container.data('facet-slug');
            const min = parseFloat(container.find('.range-min-input').val() as string);
            const max = parseFloat(container.find('.range-max-input').val() as string);
            const dataMin = parseFloat(container.data('min'));
            const dataMax = parseFloat(container.data('max'));

            // Only add filter if values differ from defaults
            if (min !== dataMin || max !== dataMax) {
                rangeFilters.set(facetSlug, { facetSlug, min, max });
            } else {
                rangeFilters.delete(facetSlug);
            }

            updateFromFilters();
        });

        // Search within facet
        $(document).on('input', '.facet-search-input', function () {
            const input = $(this);
            const facetSlug = input.data('facet-slug');
            const searchTerm = (input.val() as string).toLowerCase();
            const container = input.closest('.accordion-body');

            container.find('.facet-value-item').each(function () {
                const item = $(this);
                const searchable = item.data('searchable') || '';
                if (searchable.includes(searchTerm)) {
                    item.closest('a').show();
                } else {
                    item.closest('a').hide();
                }
            });
        });

        function handleCheckboxChange(checkbox: HTMLInputElement) {
            const checked = checkbox.checked;
            const facetSlug = checkbox.dataset.facetSlug || '';
            const valueSlug = checkbox.dataset.facetValueSlug || '';
            const facetName = checkbox.dataset.facetName || '';
            const facetValue = checkbox.dataset.facetValue || '';

            if (checked) {
                data.push({
                    FacetName: facetName,
                    FacetNameSlug: facetSlug,
                    FacetValue: facetValue,
                    FacetValueSlug: valueSlug
                });
            } else {
                data.remove(function (item) {
                    return (ko.unwrap(item.FacetNameSlug) == facetSlug && ko.unwrap(item.FacetValueSlug) == valueSlug);
                });
            }
            updateFromFilters();
        }

        function handleRadioChange(radio: HTMLInputElement) {
            const facetSlug = radio.dataset.facetSlug || '';
            const valueSlug = radio.dataset.facetValueSlug || '';
            const facetName = radio.dataset.facetName || '';
            const facetValue = radio.dataset.facetValue || '';

            // Remove all existing selections for this facet
            data.remove(function (item) {
                return ko.unwrap(item.FacetNameSlug) == facetSlug;
            });

            // Add the new selection
            data.push({
                FacetName: facetName,
                FacetNameSlug: facetSlug,
                FacetValue: facetValue,
                FacetValueSlug: valueSlug
            });

            updateFromFilters();
        }

        function syncRangeInputs(container: JQuery, source: 'slider' | 'input') {
            const facetSlug = container.data('facet-slug');
            const dataMin = parseFloat(container.data('min'));
            const dataMax = parseFloat(container.data('max'));

            let minVal: number, maxVal: number;

            if (source === 'slider') {
                minVal = parseFloat(container.find('.range-slider-min').val() as string);
                maxVal = parseFloat(container.find('.range-slider-max').val() as string);

                // Ensure min doesn't exceed max
                if (minVal > maxVal) {
                    minVal = maxVal;
                    container.find('.range-slider-min').val(minVal);
                }

                container.find('.range-min-input').val(minVal);
                container.find('.range-max-input').val(maxVal);
            } else {
                minVal = parseFloat(container.find('.range-min-input').val() as string);
                maxVal = parseFloat(container.find('.range-max-input').val() as string);

                // Clamp values
                minVal = Math.max(dataMin, Math.min(minVal, maxVal));
                maxVal = Math.min(dataMax, Math.max(minVal, maxVal));

                container.find('.range-min-input').val(minVal);
                container.find('.range-max-input').val(maxVal);
                container.find('.range-slider-min').val(minVal);
                container.find('.range-slider-max').val(maxVal);
            }
        }

        async function updateFromFilters() {
            // Build facet filter string from checkboxes/radios/toggles
            let facets: string[] = [];

            // Collect checkbox, radio, and toggle selections
            $(".facet-checkbox-v3:checked, .facet-radio-v3:checked, .facet-toggle-v3:checked").each(function (index, elem: HTMLInputElement) {
                facets.push('--' + elem.dataset.facetSlug + '_' + elem.dataset.facetValueSlug);
            });

            // Collect color swatch selections
            $(".facet-color-swatch.selected").each(function () {
                const swatch = $(this);
                facets.push('--' + swatch.data('facet-slug') + '_' + swatch.data('facet-value-slug'));
            });

            // Collect range filter selections
            rangeFilters.forEach((range) => {
                facets.push('--' + range.facetSlug + '_' + range.min + '-' + range.max);
            });

            facets.sort();

            var form = $("#filterform");
            var actionUrl = form.attr("action");
            var baseActionUrl = form.attr('data-baseactionurl');
            var query = form.attr('data-baseactionquery');

            var postData = {
                facetFilterValues: facets,
                sortBy: sortByData()
            };

            // Show loading state
            $("#catalogContainer, #facetFiltersV3 .accordion-body").css({ 'opacity': 0.5 });

            if (query != null)
                actionUrl += '?query=' + query;

            try {
                var result = await axios.post(actionUrl, postData);

                var pushUrl = facets.join("");
                var url: URL;
                if (pushUrl != '') {
                    url = new URL(baseActionUrl + '/' + pushUrl + '/' + sortByData(), window.location.origin);
                } else {
                    url = new URL(baseActionUrl + '/' + sortByData(), window.location.origin);
                }

                if (query != null)
                    url.searchParams.set("query", query);

                history.pushState({}, "", url);

                // Replace catalog container content
                $("#catalogContainer").html(result.data);

                // Re-initialize load more button after HTML replacement
                initLoadMore();

                // Remove loading state
                $("#catalogContainer, #facetFiltersV3 .accordion-body").css({ 'opacity': 1 });
            } catch (err) {
                console.error('Error updating filters:', err);
                $("#catalogContainer, #facetFiltersV3 .accordion-body").css({ 'opacity': 1 });
            }
        }
    }
};

// Global init function for inline script calls
(window as any).initFacetsV3 = function () {
    // This is called from the Razor view if needed
    console.log('FacetsV3 initialized');
};

export { FiltersV3 as default };
